<template>
  <div>
    <div class="content-i">
      <div class="content-box" style="padding-bottom: 0px;">
        <div class="element-wrapper" style="padding-bottom: 0px;">
          <h6 class="element-header">{{ t('titleManageCustomersSearch','titleManageCustomersSearch') }}</h6>
          <div class="element-box">
            <div>
              <div class="element-info">
                <div class="row">
                  <div class="col-12 col-sm-6 col-md-8">
                    <div class="element-info-with-icon">
                      <div class="element-info-icon">
                        <span class="os-icon os-icon-search2"></span>
                      </div>
                      <div class="element-info-text">
                        <h5 class="element-inner-header">{{ t('headerManageCustomersSearch','headerManageCustomersSearch') }}</h5>
                        <div class="element-inner-desc">{{ t('manageCustomersFormDesc', 'manageCustomersFormDesc') }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-3 col-md-4">
                    <i id="customersSearchToggle" v-b-toggle.search class="os-icon os-icon-arrow-up float-right text-netsend-blue showhand"></i>
                  </div>
                </div>
              </div>
              <b-collapse id="search" visible>
                <form v-on:submit.prevent="requestCustomersList">
                  <div class="col-12 row">
                    <!-- CUSTOMER MULTI REF -->
                    <div v-if="getCustomerMultiReference" class="col-md-4 col-lg-2">
                      <div class="form-group">
                        <label for="customer_multi_ref" class="d-block text-center">{{ t('manageCustomersSearchLabelCustMultiRef', 'manageCustomersSearchLabelCustMultiRef') }}</label>
                        <b-form-textarea
                            id="customer_multi_ref"
                            v-model="searchArrays.customerMultiReference"
                            :placeholder="t('manageCustomersSearchLabelCustMultiRef', 'manageCustomersSearchLabelCustMultiRef')"
                            size="sm"
                        ></b-form-textarea>
                      </div>
                    </div>
                    <!-- CUSTOMER REF -->
                    <!--NS-11213, Both filters must be present when MCS is activated, RS-->
                    <div class="col-md-4 col-lg-2">
                        <div class="form-group">
                          <label for="customer_ref" class="d-block text-center">{{ t('manageCustomersSearchLabelCustRef', 'manageCustomersSearchLabelCustRef') }}</label>
                          <input id="customer_ref" v-model="customersListRequest.customerReference" :placeholder="t('manageCustomersSearchLabelCustRef', 'manageCustomersSearchLabelCustRef')" class="form-control" type="text">
                        </div>
                      </div>
                    <div class="col-md-4 col-lg-2">
                      <!-- CUSTOMER NAME -->
                      <div class="col-12">
                        <div class="form-group">
                          <label for="customerName" class="d-block text-center">{{ t('manageCustomersSearchLabelCustName', 'manageCustomersSearchLabelCustName') }}</label>
                          <input id="customerName" v-model="customersListRequest.customerName" :placeholder="t('manageCustomersSearchLabelCustName', 'manageCustomersSearchLabelCustName')" class="form-control" type="text">
                        </div>
                      </div>
                    </div>
                    <!-- CRM CRITERIA SECTION -->
                    <div v-if="getUserLevel == 3.00" class="col-12 row" style="margin: 0px;">
                      <div class="col-12">
                        <b style="font-size: 18px;">{{ t('manageCustomersCRMCriteriaLabel', 'manageCustomersCRMCriteriaLabel') }}</b>
                      </div>
                    </div>
                    <div class="col-12 row mb-3" style="margin: 0px;">
                      <div v-if="getUserLevel == 3.00" class="col-md-6 col-lg-3 mt-4" style="padding: 0px;">
                        <div class="col-lg-12 mb-1">
                          <b-form-checkbox
                            id="callIsOverdue"
                            name="callIsOverdue"
                            value="1"
                            unchecked-value="0"
                            v-model="customersListRequest.callOverdue"
                          >
                            {{ t('manageCustomersCallOverdueLabel', 'manageCustomersCallOverdueLabel') }}
                          </b-form-checkbox>
                        </div>
                        <div class="col-lg-12 mb-1" style="display: flex; align-items: center;">
                          <b-form-checkbox
                            id="docsInLastMonths"
                            name="docsInLastMonths"
                            value="1"
                            unchecked-value="0"
                            v-model="customersListRequest.docsInLastMonths"
                            style="float: left;"
                          >
                            {{ t('manageCustomersDocInLastMonthsLabel', 'manageCustomersDocInLastMonthsLabel') }}
                          </b-form-checkbox>
                          <input id="docsInLastMonthsAmount" v-model="customersListRequest.docsInLastMonthsAmount" class="form-control text-center" style="width: 45px; margin-left: 5px; margin-right: 5px;" type="text" maxlength="2">
                          {{ t('monthsText', 'monthsText') }}
                        </div>
                        <div class="col-lg-12 mb-1">
                          <b-form-checkbox
                            id="lastEmailFailure"
                            name="lastEmailFailure"
                            value="1"
                            unchecked-value="0"
                            v-model="customersListRequest.emailFailure"
                          >
                            {{ t('manageCustomersLastEmailFailureLabel', 'manageCustomersLastEmailFailureLabel') }}
                          </b-form-checkbox>
                        </div>
                        <div class="col-lg-12 mb-1">
                          <b-form-checkbox
                            id="lastFaxFailure"
                            name="lastFaxFailure"
                            value="1"
                            unchecked-value="0"
                            v-model="customersListRequest.faxFailure"
                          >
                            {{ t('manageCustomersLastFaxFailureLabel', 'manageCustomersLastFaxFailureLabel') }}
                          </b-form-checkbox>
                        </div>
                        <div class="col-lg-12 mb-1">
                          <b-form-checkbox
                            id="lastEmailOrFaxFailure"
                            name="lastEmailOrFaxFailure"
                            value="1"
                            unchecked-value="0"
                            v-model="customersListRequest.submissionFailure"
                          >
                            {{ t('manageCustomersLastEmailOrFaxFailureLabel', 'manageCustomersLastEmailOrFaxFailureLabel') }}
                          </b-form-checkbox>
                        </div>
                      </div>
                      <div v-if="getUserLevel == 3.00" class="col-md-6 col-lg-3 mt-4">
                        <div class="col-12 mb-2">
                          <b-input-group class="col-lg-12 row">
                            <b-input-group-prepend class="col-6 label-div">
                                <label class="input-group-text">{{ t('manageCustomersEmailAddressSetLabel', 'manageCustomersEmailAddressSetLabel') }}</label>
                            </b-input-group-prepend>
                            <b-form-select class="col-6" v-model="customersListRequest.emailSet" :options="setOptions"></b-form-select>
                          </b-input-group>
                        </div>
                        <div class="col-12 mb-2">
                          <b-input-group class="col-lg-12 row">
                            <b-input-group-prepend class="col-6 label-div">
                                <label class="input-group-text">{{ t('manageCustomersFaxNumberSetLabel', 'manageCustomersFaxNumberSetLabel') }}</label>
                            </b-input-group-prepend>
                            <b-form-select class="col-6" v-model="customersListRequest.faxSet" :options="setOptions"></b-form-select>
                          </b-input-group>
                        </div>
                        <div class="col-12 mb-2">
                          <b-input-group class="col-lg-12 row">
                            <b-input-group-prepend class="col-6 label-div">
                                <label class="input-group-text">{{ t('manageCustomersTelephoneNumberSetLabel', 'manageCustomersTelephoneNumberSetLabel') }}</label>
                            </b-input-group-prepend>
                            <b-form-select class="col-6" v-model="customersListRequest.telephoneSet" :options="setOptions"></b-form-select>
                          </b-input-group>
                        </div>
                      </div>
                      <div v-if="getUserLevel == 3.00 && getDocumentTypes" class="col-md-6 col-lg-3">
                        <!-- DOCUMENT TYPE -->
                        <div class="col-lg-12">
                          <div class="form-group">
                            <label for="document_type" class="d-block text-center">{{t('manageCustomersSearchLabelDocTypes', 'manageCustomersSearchLabelDocTypes') }}</label>
                            <b-form-select id="document_type" v-model="customersListRequest.documentTypes" multiple :select-size="3" class="form-control custom-select text-capitalize" style="height: 129px;">
                              <option value="all" selected>{{t('optionAll','optionAll') }}</option>
                              <option v-for="docType in getDocumentTypes" :value="docType.id" :key="docType.id">{{ docType.name }}</option>
                            </b-form-select>
                          </div>
                        </div>
                      </div>
                      <div v-if="getUserLevel == 3.00 && getLastStatusList" class="col-md-6 col-lg-3">
                        <!-- LAST STATUS -->
                        <div class="col-lg-12">
                          <div class="form-group">
                            <label for="lastStatus" class="d-block text-center">{{t('manageCustomersLastStatusLabel', 'manageCustomersLastStatusLabel') }}</label>
                            <b-form-select id="lastStatus" v-model="customersListRequest.lastStatus" multiple :select-size="3" class="form-control custom-select text-capitalize" style="height: 129px;">
                              <option value="all" selected>{{t('optionAll','optionAll') }}</option>
                              <option v-for="status in getLastStatusList" :value="status.id" :key="status.id">
                                <span v-if="status.t_outcome_text && status.t_outcome_text != ''">{{ status.t_outcome_text }}</span>
                                <span v-else>{{ status.outcome_text }}</span>
                              </option>
                            </b-form-select>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 row mt-3">
                        <div v-if="getUserLevel == 3.00" class="col-md-4 col-lg-2">
                          <!-- NOTES CONTAIN -->
                          <div class="form-group">
                            <label for="notesContain" class="d-block text-center">{{ t('manageCustomersNotesContainLabel', 'manageCustomersNotesContainLabel') }}</label>
                            <input id="notesContain" v-model="customersListRequest.notesContain" :placeholder="t('manageCustomersNotesContainLabel', 'manageCustomersNotesContainLabel')" class="form-control" type="text">
                          </div>
                        </div>
                        <div v-if="getUserLevel == 3.00 && getImportTags" class="col-md-4 col-lg-2">
                          <!-- TAGGED AS -->
                          <div class="form-group">
                            <label for="tagged_as" class="d-block text-center">{{t('manageCustomersTaggedAsLabel', 'manageCustomersTaggedAsLabel') }}</label>
                            <b-form-select id="tagged_as" v-model="customersListRequest.importTag" class="form-control text-capitalize">
                              <option value="all" selected>{{ t('manageCustomersTagOptionAll','manageCustomersTagOptionAll') }}</option>
                              <option v-for="tag in getImportTags" :value="tag.import_tag" :key="tag.import_tag">{{ tag.import_tag }}</option>
                            </b-form-select>
                          </div>
                        </div>
                        <div class="col-md-4 col-lg-2" v-if="getPrinciplesList">
                          <!-- PRINCIPLES LIST -->
                          <div class="form-group">
                            <label for="principle_list" class="d-block text-center">{{ t('manageCustomersPrincipleListLabel', 'manageCustomersPrincipleListLabel') }}</label>
                            <b-form-select id="principle" v-model="customersListRequest.principle" class="form-control text-capitalize">
                              <option value=''></option>
                              <option v-for="principle in getPrinciplesList" :value="principle.id" :key="principle.name">{{ principle.name }}</option>
                            </b-form-select>
                          </div>
                        </div>
                      </div>
                      <!-- USE RESULTS IN CALLING CAMPAIGN -->
                      <div v-if="getUserLevel == 3.00" class="col-12 mb-2 mt-1">
                        <b-form-checkbox
                          id="useResultsInCampaign"
                          name="useResultsInCampaign"
                          value="1"
                          unchecked-value="0"
                        >
                          {{ t('manageCustomersUseResultsInCampaignLabel', 'manageCustomersUseResultsInCampaignLabel') }}
                        </b-form-checkbox>
                      </div>
                      <!-- DEFAULT IS PRIMARY CONTACTS ONLY -->
                      <div v-if="getUserLevel == 3.00" class="col-12">
                        <b-form-checkbox
                          id="defaultIsPrimary"
                          name="defaultIsPrimary"
                          value="1"
                          unchecked-value="0"
                          v-model="customersListRequest.primaryContact"
                        >
                          <b>{{ t('manageCustomersDefaultIsPrimaryLabel', 'manageCustomersDefaultIsPrimaryLabel') }}</b>
                        </b-form-checkbox>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-12 row">
                    <div class="col-2">
                      <b-input-group class="col-lg-12">
                        <b-input-group-prepend>
                            <label class="input-group-text">{{ t('recordsPerPageFilter', 'recordsPerPageFilter') }}</label>
                        </b-input-group-prepend>
                        <!-- NS-9784, request search on per page option change, PW -->
                        <b-form-select v-model="perPage" :options="pageOptions" @change="searchPageCustomers()"></b-form-select>
                      </b-input-group>
                    </div>
                    <div v-if="getUserLevel == 3.00" class="col-10" style="text-align: right; padding-right: 0px;">
                      <button v-if="!isBusy" class="btn btn-primary" type="submit" >{{ t('searchCustomersBtn','searchCustomersBtn') }}</button>
                      <b-button v-else variant="primary" disabled>
                        <b-spinner small type="grow"></b-spinner>
                        {{ t('searchCustomersBtn','searchCustomersBtn') }}
                      </b-button>
                    </div>
                    <div v-else class="col-lg-2 col-md-2 col-sm-2 text-right">
                      <div class="col-12">
                        <button class="btn btn-primary" type="submit" >{{ t('searchDeliveryReportsBtn','searchDeliveryReportsBtn') }}</button>
                      </div>
                    </div>
                  </div>
                </form>
              </b-collapse>
            </div>
          </div>
        </div>
      </div>
    </div>
		<div style="padding-left: 30px; padding-right: 30px">
			<transition name="fade">
				<ResponseInfo v-if="['manageCustomers', 'CustomerUserDeliveryOptions'].includes(getResponseInfo.responseName)" class="mt-2"/>
			</transition>
		</div>
    <div class="content-i" v-if="requestSent">
      <div class="content-box" style="padding-top: 10px;">
        <div class="element-wrapper">
          <div class="element-box">
            <div class="element-box-tp">
              <div class="controls-below-table">
                  <div class="col-sm-12 col-md-6 table-records-info" v-if="getCustomersList">
                    <p>{{ totalRows }} {{ t('customersListEntriesFound','customersListEntriesFound') }}</p>
                  </div>
                  <div class="col-sm-12 col-md-4" v-if="getCustomersList">
                    <b-pagination class="float-right mb-0" v-model="currentPage" v-if="totalRows > 0" :total-rows="totalRows" :per-page="perPage" aria-controls="logs-table">
                    </b-pagination>
                  </div>
                  <div class="col-sm-12 col-md-2">
                    <form v-on:submit.prevent>
                      <b-input-group class="form-group col-lg-12">
                        <b-input-group-prepend>
                          <label class="input-group-text">{{ t('paginationPerPage','paginationPerPage') }}</label>
                        </b-input-group-prepend>
                        <!-- NS-9784, request search on per page option change, PW -->
                        <b-form-select v-model="perPage" :options="pageOptions" @change="changePerPage"></b-form-select>
                      </b-input-group>
                    </form>
                  </div>
              </div>
              <button class="btn btn-danger" v-if="!isBusy" :disabled="selectedCustomers.length <= 0" @click="modalCreator({id: 'ModalDeleteCustomers', title: t('deleteSelectedCustomersModalTitle', 'deleteSelectedCustomersModalTitle'), selectedCustomers: selectedCustomers}, $event.target)">{{ t('deleteSelectedCustomersBtn','deleteSelectedCustomersBtn') }}</button>
              <b-button v-else variant="danger" disabled>
                <b-spinner small type="grow"></b-spinner>
                {{ t('deleteSelectedCustomersBtn','deleteSelectedCustomersBtn') }}
              </b-button>
<!--              table start-->
              <div class="table-responsive">
                <b-table id="logs-table" striped hover bordered class="mt-3 " :busy.sync="isBusy" v-if="getCustomersList.data" :items="getCustomersList.data" :fields="fields" :total-rows="totalRows" :per-page="0" :currentPage="currentPage" :show-empty="rowEmpty" @sort-changed="changeSorting" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" >
                  <template class="busy-row" slot="table-busy" slot-scope="items" v-bind:value="data.item">
                    <!--<div class="vld-parent spinner-row">
                      <loading :active.sync="isBusy"
                      :can-cancel="false"
                      :color="'#047bf8'"
                      :loader="'dots'"
                      :is-full-page="false"></loading>
                    </div>-->
                    <vcl-table :rows="parseInt(perPage)" :columns="4"></vcl-table>
                  </template>
                  <template slot="empty" slot-scope="items">
                    <span>{{ t('customersListNoEntries','customersListNoEntries') }}</span>
                  </template>
                  <template v-slot:head(selectCustomer)="data">
                    <template v-if="!selectAll">
                      <fontAwesomeIcon @click="checkAllCustomers()" :icon="['far', 'square']" class="showhand text-center" size="lg"/>
                    </template>
                    <template v-if="selectAll">
                      <fontAwesomeIcon @click="uncheckAllCustomers()" :icon="['far', 'check-square']" class="showhand text-center" size="lg"/>
                    </template>
                  </template>
                  <template v-slot:head(customerReference)="data">
                    <span >{{ t(data.label, data.label) }}</span>
                  </template>
                  <template v-slot:head(customerName)="data">
                    <span >{{ t(data.label, data.label) }}</span>
                  </template>
                  <template v-slot:head(customerDocumentsNum)="data">
                    <span >{{ t(data.label, data.label) }}</span>
                  </template>
                  <template v-slot:cell(selectCustomer)="data">
                    <div style="margin: auto; width: 50%;">
                      <b-form-checkbox :value="data.item.custId" v-model="selectedCustomers"></b-form-checkbox>
                    </div>
                  </template>
                  <template v-slot:cell(customerReference)="data">
                    <span>{{ data.item.reference }}</span>
                  </template>
                  <template v-slot:cell(customerName)="data">
                    <span>{{ data.item.name }}</span>
                  </template>
                  <template v-slot:cell(customerDocumentsNum)="data">
                    <span>{{ data.item.num_of_docs }}</span>
                  </template>
                  <template v-slot:cell(buttonsSection)="data">
                    <router-link class="btn btn-primary" :to="{ name: 'customer_view', params: { id: data.item.custId } }">
                      {{ t('mngCustomersDetailsBtn', 'mngCustomersDetailsBtn') }}
                    </router-link>
                    <router-link class="btn btn-primary" :to="{ name: 'documents_search', query: { customer_ref: data.item.reference } }">
                      {{ t('mngCustomersDocumentsBtn', 'mngCustomersDocumentsBtn') }}
                    </router-link>
                    <router-link class="btn btn-primary" :to="{ name: 'delivery_reports', query: { customer_reference: data.item.reference, customer_name: data.item.name } }">
                      {{ t('mngCustomersDeliveryReportsBtn', 'mngCustomersDeliveryReportsBtn') }}
                    </router-link>
                    <router-link class="btn btn-primary" :to="{ name: 'customer_delivery_options', params: { id: data.item.custId } }">
                      {{ t('mngCustomersDeliveryOptionsBtn', 'mngCustomersDeliveryOptionsBtn') }}
                    </router-link>
                    <b-link class="btn btn-primary" @click="modalCreator({id: 'ModalSendLoginDetails', title: t('sendEmailCustomerDetailsModalTitle', 'sendEmailCustomerDetailsModalTitle'), custId: data.item.custId}, $event.target)">
                      {{ t('mngCustomersSendLoginDetailsBtn', 'mngCustomersSendLoginDetailsBtn') }}
                    </b-link>
                    <router-link class="btn btn-primary" :to="{ name: 'customer_coversheets', params: { id: data.item.custId } }">
                      {{ t('mngCustomersCoversheetsBtn', 'mngCustomersCoversheetsBtn') }}
                    </router-link>
                    <b-link class="btn btn-primary" @click="openAddModal(data, t('addCustomerUserModalTitle','addCustomerUserModalTitle'), $event.target)">
                     {{ t('mngCustomersAddUserBtn', 'mngCustomersAddUserBtn') }}
                    </b-link>
                  </template>
                </b-table>
              </div>
<!--              table end-->
              <div class="controls-below-table pt-4">
                  <div class="col-12 col-md-6 table-records-info" v-if="getCustomersList">
                    <p class="mb-0">{{ totalRows }} {{ t('customersListEntriesFound','customersListEntriesFound') }}</p>
                  </div>
                  <div class="col-sm-12 col-md-4" v-if="getCustomersList">
                    <b-pagination class="float-right mb-0" v-model="currentPage" :total-rows="totalRows" :per-page="perPage" aria-controls="logs-table" v-if="totalRows > 0">
                    </b-pagination>
                  </div>
                  <div class="col-sm-12 col-md-2">
                      <b-input-group class="form-group col-lg-12">
                        <b-input-group-prepend>
                          <label class="input-group-text">{{ t('paginationPerPage','paginationPerPage') }}</label>
                        </b-input-group-prepend>
                        <b-form-select v-model="perPage" :options="pageOptions" @change="changePerPage"></b-form-select>
                      </b-input-group>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="overlayBackgroundDisplay" class="modal-backdrop show"></div>
    <ModalSendLoginDetails :modal="this.modal"/>
    <ModalAddCustomerUser :modal="this.addModal" @hide="resetAddModal"/>
    <ModalDeleteCustomers :modal="this.modal"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { clientShortName } from '@/helpers/clientShortName.js'
import moment from 'moment'
import Loading from 'vue-loading-overlay';
import debounce from '../helpers/debounce';
import ResponseInfo from '@/components/ResponseInfo.vue'
import { VclTable } from 'vue-content-loading'
import ModalSendLoginDetails from '@/components/Manage_Users/ModalSendLoginDetails.vue'
import ModalAddCustomerUser from '@/components/Manage_Users/ModalAddCustomerUser.vue'
import ModalDeleteCustomers from '@/components/Manage_Users/ModalDeleteCustomers.vue' //NS-9783 SP Delete customers modal
import 'bootstrap-vue/dist/bootstrap-vue.css'

export default {
  name: 'ManageCustomers',
  provide() {
		return {
			resetModal: this.resetModal,
		}
	},
  data() {
    return {
      fields: [
        {key: 'selectCustomer', label: 'selectCustomerLabel', thClass: 'showhand brand-color'},
        {key: 'customerReference', label: 'manageCustomersTableCustRefLabel', sortable: true, thClass: 'showhand brand-color', tdClas: 'text-left'},
        {key: 'customerName', label: 'manageCustomersTableCustNameLabel', sortable: true, thClass: 'showhand brand-color', tdClass: 'text-center', thStyle: 'width: 13%'},
        {key: 'customerDocumentsNum', label: 'manageCustomersTableCustDocumentsNumLabel', sortable: true, thClass: 'showhand brand-color'},
        {key: 'buttonsSection', label: '', thClass: 'brand-color', tdClass: 'white-space'}
      ],

      //#EIPP-550 binding debounce to this , IS
      debounce: debounce.bind(this),
      customersList: null,
      selectAll: 0,
      selectedCustomers: [],
      sortBy: null,
      sortDesc: false,
      pageOptions: [10, 20, 50, 100],
      setOptions: [
        { value: 1, text: 'yes'},
        { value: 0, text: 'no'}
      ],

      filter: null,
      isBusy: false,
      rowEmpty: false,
      totalRows: 0,
      filteredRows: '',

      currentPage: this.$route.query.page ? this.$route.query.page : 1,
      perPage: this.$route.query.per_page ? this.$route.query.per_page : 20,

      modal: {
        modalData: {},
        updateData: {}
      },

      overlayBackgroundDisplay: false,
      requestSent: false,

      customersListRequest: {
        page: 1,
        per_page: 20,
        customerReference: this.$route.query.customerReference,
        customerMultiReference: this.$route.query.customerMultiReference ? this.$route.query.customerMultiReference : "",
        customerName: this.$route.query.customerName,
        emailSet: this.$route.query.emailSet ? this.$route.query.emailSet : 0,
        faxSet: this.$route.query.faxSet ? this.$route.query.faxSet : 0,
        telephoneSet: this.$route.query.telephoneSet ? this.$route.query.telephoneSet : 0,
        notesContain: this.$route.query.notesContain,
        importTag: this.$route.query.importTag || 'all',
        principle: this.$route.query.principle ? this.$route.query.principle : '',
        documentTypes: this.$route.query.document_type || ['all'],
        lastStatus: this.$route.query.lastStatus || ['all'],
        primaryContact: this.$route.query.primaryContact ? this.$route.query.primaryContact : 0,
        docsInLastMonths: this.$route.query.docsInLastMonths ? this.$route.query.docsInLastMonths : 0,
        docsInLastMonthsAmount: this.$route.query.docsInLastMonthsAmount ? this.$route.query.docsInLastMonthsAmount : 0,
        callOverdue: this.$route.query.callOverdue ? this.$route.query.callOverdue : 0,
        sort_field: this.$route.query.sort_field,
        sort_direction: this.$route.query.sort_direction
      },
      searchArrays: {
        customerMultiReference: '',
      },
      addModal: {
        id: 'addCustomerUserModal',
        title: '',
        customerId: '',
        accountNumber: '',
      },
    }
  },
  methods: {
    // search for customers only if the customers have already been looked for, NS-9784, PW
    searchPageCustomers() {
      if(!this.rowEmpty && this.getCustomersList.data) {
        this.requestCustomersList()
      }
    },
    requestCustomersList() {
      this.$store.dispatch('alertClearResponse')

      // NS-10823 search setup - customerMultiReference, VY
      if (this.searchArrays.customerMultiReference && this.searchArrays.customerMultiReference.length !== 0) {
        if (typeof this.searchArrays.customerMultiReference == 'string') {
          if (this.searchArrays.customerMultiReference.includes(',')) {
            let multiRef = this.searchArrays.customerMultiReference.split(',')
            Object.keys(multiRef).forEach((key) => (multiRef[key] = multiRef[key].trim()))
            multiRef = multiRef.filter(function(value, index, arr){
              return value !== "";
            });
            this.customersListRequest.customerMultiReference = multiRef
          } else if (this.searchArrays.customerMultiReference.match(/\n/g)) {
            let multiRef = this.searchArrays.customerMultiReference.split(/\r?\n/)
            Object.keys(multiRef).forEach((key) => (multiRef[key] = multiRef[key].trim()))
            multiRef = multiRef.filter(function(value, index, arr){
              return value !== "";
            });
            this.customersListRequest.customerMultiReference = multiRef
          } else {
            this.customersListRequest.customerMultiReference = this.searchArrays.customerMultiReference.trim()
          }
        }
      }

      Object.keys(this.customersListRequest).forEach((key) => ((this.customersListRequest[key] == '') || (this.customersListRequest[key] == null)) && (this.customersListRequest[key] = undefined))
      this.$router.push({ query: { ...this.$route.query, ...this.customersListRequest, page: this.currentPage, per_page: this.perPage }})

      if(!this.customersListRequest.documentTypes) {
        this.customersListRequest.documentTypes = ['all']
      }

      if(!this.customersListRequest.lastStatus) {
        this.customersListRequest.lastStatus = ['all']
      }
      
      this.isBusy = true

      this.$store.dispatch('manageCustomersStore/getManageCustomersList', {
        page: this.currentPage,
        per_page: this.perPage,
        customersRequest: this.customersListRequest
      }).then(() => {
        this.requestSent = true 
        this.isBusy = false
        this.totalRows = this.getCustomersList.total
        if((this.getCustomersList.data === undefined) || (this.getCustomersList.data.length == 0)){
          this.rowEmpty = true
        }

      })
    },
    openAddModal(row, title, button) {
      this.addModal.title = title
      this.addModal.customerId = row.item.custId
      this.addModal.accountNumber = row.item.reference
      this.$root.$emit('bv::show::modal', this.addModal.id, button)
      this.overlayBackgroundDisplay = true
    },
    resetAddModal() {
      this.addModal.title = ''
      this.addModal.accountNumber = ''
      this.addModal.customerId = 0
      this.$store.commit('manageCustomersStore/setCustomerUserExists', false)
      this.$store.commit('alertClearErrors', null)
      this.overlayBackgroundDisplay = false
    },
		modalCreator(modalData, button) {
			if(modalData.id == 'ModalSendLoginDetails') {
				this.$store.dispatch('manageCustomersStore/getCustomerUsersDetails', {
					customerId: modalData.custId 
				}).then(() => {
          this.modal.modalData = this.$store.getters['manageCustomersStore/getEmailForm']
          this.modal.modalData.title = modalData.title
          this.modal.modalData.custId = modalData.custId
          this.modal.modalData.component = 'customerUsers'
          this.modal.modalData.selectedEmail = this.modal.modalData.emails[0].email
					this.$root.$emit('bv::show::modal', modalData.id, button)
				})
			} else {
				this.modal.modalData = modalData
				this.$root.$emit('bv::show::modal', this.modal.modalData.id, button)				
			}

			this.overlayBackgroundDisplay = true
		},    
    resetModal(level, button = '') {
      if(level == 'main') {
        Object.keys(this.modal['modalData']).forEach((key) => (key === 'id') ? this.modal['modalData'][key] : (this.modal['modalData'][key] = '' ))
				Object.keys(this.modal['updateData']).forEach((key) => (this.modal['updateData'][key] = '' ))
				this.overlayBackgroundDisplay = false
        //this.$store.dispatch('alertClearResponse')
			}
    },
    
    // get doc types, status and principle filters, NS-9773 PW
    getCustomerFilters() {
      this.$store.dispatch('manageCustomersStore/getCustomerFilters')
    },
    //NS-9783 SP check all customers
    checkAllCustomers() {
      let allCustomerIds = []
      let customers = this.getCustomersList.data
      
      Object.keys(customers).forEach((key) => (allCustomerIds.push(customers[key].custId)))

      this.selectedCustomers = allCustomerIds
      this.selectAll = 1
    },
    //NS-9783 SP uncheck all customers
    uncheckAllCustomers() {
      this.selectAll = 0
      this.selectedCustomers = []
    },
    changeSorting({sortBy , sortDesc }) {
      let direction = sortDesc ? "DESC" : "ASC";
      this.$route.query.sort_field = sortBy
      this.customersListRequest.sort_field = sortBy
      this.$route.query.sort_direction = direction
      this.customersListRequest.sort_direction = direction
      this.requestCustomersList();
    },
    changePerPage(perPage){
      this.$route.query.per_page = perPage;
      this.customersListRequest.per_page = perPage;
      this.perPage = perPage;
    }
  },
  components: {
    VclTable,
    ModalSendLoginDetails,
    ModalAddCustomerUser,
    ModalDeleteCustomers, //NS-9783 SP Delete customers modal
    ResponseInfo
  },
  computed: {
    ...mapGetters(['getResponseInfo', 'getIsNewsnet', 'getUserLevel', 'allTemplateDetails']),
    ...mapGetters('manageCustomersStore', ['getCustomersList', 'getDocumentTypes', 'getImportTags', 'getPrinciplesList', 'getLastStatusList', 'getCustomerMultiReference']),
    //#EIPP-550 added the getMutableData function to get the data which needs to be watched for the changes on the page for each request. IS
    getMutableData(){
      let { page , per_page , sort_field , sort_direction } = this.customersListRequest;
      return {
        currentPage: this.currentPage ,
        page ,
        per_page ,
        sort_field ,
        sort_direction
      };
    }
  },
  created() {
    // get doc types, status and principle filters, NS-9773 PW
    this.getCustomerFilters()
    // uncaught exception object error
    this.$router.push({ query: {  ...this.$route.query } });

    //#EIPP-550 setup debounce for this requestCustomersList function call.
    this.requestCustomersList = this.debounce(this.requestCustomersList , 1);

    if(Object.keys(this.$route.query).length) {
        this.customersListRequest = Object.assign({}, this.$route.query)
    }
    // NS-10823 check customer multi reference, VY
    if (this.$route.query.customerMultiReference) {
      if (Array.isArray(this.$route.query.customerMultiReference)) {
        let multiRef = []
        Object.keys(this.$route.query.customerMultiReference).forEach(
            (key) => (
                (multiRef.push(this.$route.query.customerMultiReference[key]))
            )
        )
        this.customersListRequest.customerMultiReference = multiRef
        this.searchArrays.customerMultiReference = multiRef.toString()
      } else {
        this.customersListRequest.customerMultiReference = this.$route.query.customerMultiReference
        this.searchArrays.customerMultiReference = this.$route.query.customerMultiReference
      }
    }

    if(typeof this.customersListRequest.documentTypes == 'string') {
      this.customersListRequest.documentTypes = new Array(this.customersListRequest.documentTypes)
    }
    if(typeof this.customersListRequest.lastStatus == 'string') {
      this.customersListRequest.lastStatus = new Array(this.customersListRequest.lastStatus)
    }

    if(this.$route.query.page) {
      this.currentPage = parseInt(this.$route.query.page)
      if(isNaN(this.currentPage)) {
        this.currentPage = 1
      }
    } else {
      this.currentPage = 1
    }

    if(this.$route.query.per_page) {
      this.perPage = parseInt(this.$route.query.per_page)
      if(isNaN(this.perPage)) {
        this.perPage = 20
      }
    } else {
      this.perPage = 20
    }

    if(Object.keys(this.$route.query).length) {
      this.requestCustomersList();
    } else {
      this.$store.commit('manageCustomersStore/setCustomersList', [])
    }
  },
  watch: {
    //#EIPP-550 watches everything inside getMutable data in computed. IS
    getMutableData() {
      this.requestCustomersList()
    }
  }
}
</script>

<style scoped>
  .text-netsend-blue {
    color: #047bf8;
  }
  #customersSearchToggle {
    font-size: 1.2rem;
    font-weight: bold;
    display:inline-block;
    -moz-transition: all .5s linear;
    -webkit-transition: all .5s linear;
    transition: all .5s linear;
    cursor: pointer;
  }
  #customersSearch.collapsed {
    -moz-transform:rotate(180deg);
    -webkit-transform:rotate(180deg);
    transform:rotate(180deg);
  }
  .table-responsive  >>> .brand-color {
    background-color: #047bf8 !important;
    color: white !important;
  }
  .table-records-info > p {
    margin-bottom: 0px;
  }
  .busy-row {
    display: contents;
  }
  .spinner-row {
    min-height: 150px;
  }
  .table-records-info {
    display: flex;
    align-items: center;
  }
  table >>> tbody, table >>> thead {
    text-align: center;
  }
  table {
    max-width: 100%;
  }
  .label-div {
    padding: 0px;
  }
  .label-div > label {
    width: 100%;
    max-width: 100%;
  }
</style>